import { ImageIcon } from 'lucide-react'

import { cn } from '@/lib/utils'

type CrewTemplateLogoProps = {
  logoUrl?: string | null
  name: string
  className?: string
}

export function CrewTemplateLogo({ logoUrl, name, className }: CrewTemplateLogoProps) {
  if (logoUrl) {
    return (
      <img
        src={logoUrl}
        alt={`${name} logo`}
        className={cn('h-9 w-9 rounded-lg border border-border/70 bg-background object-cover', className)}
      />
    )
  }

  return (
    <div
      className={cn(
        'flex h-9 w-9 items-center justify-center rounded-lg border border-border/70 bg-muted/40 text-muted-foreground',
        className,
      )}
    >
      <ImageIcon className="h-4 w-4" />
    </div>
  )
}
